import { httpClient } from '@/services/http/httpClient'

type GetUsersProjectParams = {
  projectId: string
}

export type GetUsersProjectResponse = {
  id: string
  name: string
  email: string
  image: string
  type: string
  status: string
}
export const getUsersProject = async (params: GetUsersProjectParams) => {
  const { data } = await httpClient.get<GetUsersProjectResponse[]>(
    `/projects/portfolio-projects/${params.projectId}/users`,
  )

  return data
}
